import React from "react";
import ErrorHandler from "../../../components/shared/with-error-handler";
import withReducer from "../../../components/shared/with-reducer";
import withLayout from "../../../components/desktop/layout/component";
import CarServiceHistory from "../../../components/desktop/car-service-history";
import injectable from "./injectable";

const CarServiceHistoryContainer = () => {
    return (
        <ErrorHandler>
            <CarServiceHistory />
        </ErrorHandler>
    );
};

export default withReducer(injectable)(() => ({}), dispatch => ({dispatch}))(
    withLayout(
        CarServiceHistoryContainer,
        true,
        true,
        false,
        false
    )
);
